import { useEffect } from 'react';

export default function useSEO({ title, description, canonical }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      const og = document.querySelector('meta[property="og:title"]');
      if (og) og.content = title;
      const tw = document.querySelector('meta[name="twitter:title"]');
      if (tw) tw.content = title;
    }
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.content = description;
      const og = document.querySelector('meta[property="og:description"]');
      if (og) og.content = description;
      const tw = document.querySelector('meta[name="twitter:description"]');
      if (tw) tw.content = description;
    }
    if (canonical) {
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.href = canonical;
      const og = document.querySelector('meta[property="og:url"]');
      if (og) og.content = canonical;
    }
  }, [title, description, canonical]);
}
